import { useEffect, useState } from "react";
import { api, fmtCurrency } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Plus, Users as UsersIcon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function BusinessCustomers() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", phone: "" });
    const refresh = () => api.get("/business/customers").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);

    const submit = async () => {
        if (!form.name) return toast.error("Name required");
        await api.post("/business/customers", form);
        setOpen(false); setForm({ name: "", phone: "" }); refresh(); toast.success("Customer added");
    };

    return (
        <div data-testid="customers-page">
            <MobileHeader title="Customers" backTo="/business/more" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-3">
                <div className="bg-white rounded-2xl border border-slate-200/60 overflow-hidden product-shadow">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No customers</div>}
                    {items.map((c, i) => (
                        <div key={c.id} className={`flex items-center gap-3 px-4 py-3.5 ${i !== items.length - 1 ? "border-b border-slate-100" : ""}`} data-testid={`customer-${c.id}`}>
                            <div className="size-10 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center"><UsersIcon size={18} /></div>
                            <div className="flex-1"><div className="font-semibold text-sm">{c.name}</div><div className="text-xs text-slate-500">{c.phone || "—"}</div></div>
                        </div>
                    ))}
                </div>
                <Button onClick={() => setOpen(true)} className="w-full h-12 rounded-xl bg-[#0066FF]" data-testid="add-customer-btn"><Plus size={18} /> Add Customer</Button>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="rounded-2xl">
                    <DialogHeader><DialogTitle>New Customer</DialogTitle></DialogHeader>
                    <div className="space-y-3">
                        <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="cust-name" /></div>
                        <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="cust-phone" /></div>
                        <Button onClick={submit} className="w-full h-11 rounded-xl bg-[#0A1930]" data-testid="cust-submit">Add</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
